export default "__VITE_ASSET__DWRYnOww__"